import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const pelicanShoresMetadata = {
  id: 'pelican-shores',
  name: 'Pelican Shores',
  description:
    'A bright tropical coastal resort routed broadly through palm-lined wetlands, lagoons and sandy native areas.',
  environmentPreset: 'tropical-wetlands',
  metadata: {
    location: 'Gulf Coast',
    regionType: 'coastal wetlands',
    difficulty: 76,
    typicalWind: [6, 16] as const,
    greenSpeed: [10, 10.5] as const,
    firmness: 'medium-soft' as const,
    primaryChallenge: 'Wetland golf on a broad horizon',
    signatureHoles: [5, 7, 12, 18],
    tournamentEventId: 'event-12',
    previewTheme: 'tropical-wetlands',
    environmentPalette: {
      fairway: '#74a85a',
      rough: '#567f45',
      bunker: '#f0d59b',
      water: '#3daab5',
      haze: '#bfe8e5',
      sky: '#71c9e8',
      rock: '#8b7965',
      wasteArea: '#ddc68d',
    },
    vegetationStyle: 'palm and coastal grass, medium density',
    terrainStyle: terrainPreset('tropical-wetlands', 12, 150, 1.1).id,
    sunlightDirection: 'east-southeast morning sun',
    distantScenery: 'ocean horizon and wetland flats',
    waterStyle: 'clear turquoise lagoon reflections',
    eventPresentation: {
      accentColor: '#71c9e8',
      mark: 'PELICAN',
      subtitle: 'Coastal precision',
      loadingCopy: 'Angles on the ocean breeze',
      identityLine: 'Wetland golf on a broad horizon',
      tierLabel: 'STANDARD',
    },
    wasteArea: { carryMultiplier: 0.91, consistencyMultiplier: 0.88, rollMultiplier: 0.72 },
  },
};
const pars = [4, 4, 5, 3, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4];
const yards = [
  405, 430, 545, 150, 325, 425, 180, 565, 440, 410, 165, 550, 435, 420, 185, 530, 400, 450,
];
const names = [
  'Trade Wind',
  'Palm Reach',
  'Lagoon Routes',
  'Blue Heron',
  'Wetland Temptation',
  'Ocean Shelf',
  'Lagoon Leap',
  'Pelican Fork',
  'Humid Turn',
  'Sandy Native',
  'Mangrove',
  'Broadwater',
  'Resort Line',
  'Salt Grass',
  'Bright Bay',
  'Two Shores',
  'Last Palm',
  'Home Lagoon',
];
const options: Partial<HolePlan>[] = [];
options[3] = { water: 'carry', greenRadius: 20 };
options[4] = {
  water: 'right',
  splitFairway: true,
  landingZones: [{ distance: 260, width: 62, preferredSide: 'left' }],
};
options[7] = {
  water: 'left',
  splitFairway: true,
  landingZones: [{ distance: 275, width: 65, preferredSide: 'right' }],
};
options[17] = {
  water: 'green',
  landingZones: [{ distance: 275, width: 52, preferredSide: 'left' }],
};
export const createPelicanShoresDocument = () =>
  authorCourse({
    ...pelicanShoresMetadata,
    plans: plans(names, pars, yards, options).map((plan) => ({
      ...plan,
      elevation: {
        tee: 0,
        landing: (plan.elevation?.landing ?? 0) * 0.25,
        green: (plan.elevation?.green ?? 0) * 0.25,
      },
      trees: plan.trees ?? 5,
      rocks: plan.rocks ?? 0,
    })),
  });
